import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "7a65b852-8994-41d9-8103-69a9a45ead77", content: "Initialize rays", options: {} },
  { id: "819359d9-3299-4fb9-981b-f790bd47f71a", content: "Shoot rays", options: {} },
  { id: "54d1525a-7e1c-4ea8-bf5c-905a60e6212c", content: "Bounce rays off<br>reflecting surfaces", options: {} },
  { id: "bbc385f4-3daf-436a-aa6d-82eec63ac0f5", content: "Collect rays at the<br>detector", options: {} },
  { id: "355ef4f5-b9dd-406a-9f42-f22fb98aacc3", content: "Convert rays<br>to energy", options: {} },
  { id: "de2e0fb9-bf0c-49bb-81f5-4b560953a35e", content: "Insert into<br>the histogram", options: {} },
];

const groups = [
  { id: "20fa7c38-1754-48f7-8e20-67be3c0be0aa", content: "1", options: {} },
  { id: "f3ab43a7-25ad-4249-bcdc-5b9e3b8f7998", content: "2", options: {} },
  { id: "0245d8db-86b4-4727-9f90-40bbafb37ec0", content: "3", options: {} },
  { id: "bda004f8-1f97-43b9-b98c-fb2854a2ab4f", content: "4", options: {} },
  { id: "4078c332-9a2f-4f16-b200-ea69b8fbe1cb", content: "5", options: {} },
  { id: "a5bef123-cb90-4fcf-af8d-4cc900df0cb6", content: "6", options: {} },
];

export const task: Task = {
  id: "5826ebb3-6594-4ffd-8fe8-e2190eb216d9",
  solutionType: "order",
  type: "orderLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "7a65b852-8994-41d9-8103-69a9a45ead77",
    "819359d9-3299-4fb9-981b-f790bd47f71a",
    "54d1525a-7e1c-4ea8-bf5c-905a60e6212c",
    "bbc385f4-3daf-436a-aa6d-82eec63ac0f5",
    "355ef4f5-b9dd-406a-9f42-f22fb98aacc3",
    "de2e0fb9-bf0c-49bb-81f5-4b560953a35e",
  ],
};
